<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Tomador" />
      <Lynx-Button @click.native="voltar()">Voltar</Lynx-Button>
    </div>
    <form
      class="w-full"
      @submit.prevent="confirm(lista_campos == '' ? 'cria' : 'edita')"
    >
      <div class="flex justify-between items-center gap-4">
        <label class="flex flex-col w-full pb-8">
          <Lynx-Label label="Razão Social" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite a razão social"
            v-model="form.razao_social"
          />
        </label>
        <label class="flex flex-col w-2/4 pb-8">
          <Lynx-Label label="CNPJ/CPF Tomador" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite cpf ou cnpj"
            v-model="form.cpf_cnpj"
          />
        </label>
        <label class="flex flex-col w-2/4 pb-8">
          <Lynx-Label label="Celular" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite o celular"
            v-model="form.celular"
          />
        </label>
      </div>

      <div class="flex justify-between items-start gap-4">
        <label class="flex flex-col w-1/3">
          <div class="flex justify-between items-center mb-3">
            <!-- Elemento à Esquerda -->
            <div class="ml-2">
              <b-switch :value="emails.length > 0" @input="setEmails()" />
            </div>

            <!-- Label no Meio -->
            <Lynx-Label label="Email(s) do Tomador" />

            <!-- Elemento à Direita -->
            <div class="flex items-end mb-2">
              <v-btn
                fab
                x-small
                icon
                color="primary"
                elevation="2"
                @click="emails.push('')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- Lista de Emails -->
          <div class="row">
            <div
              v-for="(email, index) in emails"
              :key="index"
              class="col-md-12 row"
            >
              <label class="flex flex-col w-2/3">
                <Lynx-Input
                  :disabled="admin"
                  placeholder="Digite o email do Tomador"
                  v-model="emails[index]"
                />
              </label>

              <!-- Botão de Remoção -->
              <v-btn
                class="ml-1"
                icon
                color="error"
                elevation="2"
                @click="removeEmail(index)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </div>
          </div>
        </label>

        <label class="flex flex-col w-1/3 pb-8">
          <Lynx-Label label="Email do Financeiro" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite email do Tomador"
            v-model="form.email_financeiro"
          />
        </label>
        <label class="flex flex-col w-1/3 pb-8">
          <Lynx-Label label="Email Notificavel" />

          <div class="flex flex-col">
            <b-radio
              class="mb-2"
              v-model="form.notificavel"
              native-value="financeiro"
            >
              {{ form.email_financeiro }}
            </b-radio>
            <div v-for="(email, index) in emails" :key="index">
              <b-radio
                value="mb-2"
                v-model="form.notificavel"
                :native-value="emails[index]"
              >
                {{ emails[index] }}
              </b-radio>
            </div>
          </div>
        </label>
      </div>
      <div class="flex justify-between items-center gap-4">
        <label class="flex flex-col w-1/4 pb-8">
          <Lynx-Label label="CEP" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite o cep"
            v-model="form.cep"
            @input="fetchCep"
          />
        </label>
        <label class="flex flex-col w-full pb-8">
          <Lynx-Label label="Endereço" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite o endereço"
            v-model="form.endereco"
          />
        </label>

        <label class="flex flex-col w-1/4 pb-8">
          <Lynx-Label label="Número" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite o número"
            v-model="form.numero"
          />
        </label>
      </div>
      <div class="flex justify-between items-center gap-4">
        <label class="flex flex-col w-full pb-8">
          <Lynx-Label label="Complemento" />

          <Lynx-Input
            :disabled="admin"
            placeholder="Digite o complemento"
            v-model="form.complemento"
          />
        </label>

        <label class="flex flex-col w-1/3 pb-8">
          <Lynx-Label label="Estados" />

          <Treeselect
            :disabled="admin"
            :options="lista_estados"
            placeholder="Selecione o estado"
            v-model="form.estado_id"
          />
        </label>
        <label class="flex flex-col w-1/3 pb-8">
          <Lynx-Label label="Cidades" />

          <Treeselect
            :disabled="admin"
            :options="lista_cidades"
            placeholder="Selecione a cidae"
            v-model="form.cidade_id"
          />
        </label>
      </div>
      <div class="flex justify-between items-center gap-4">
        <label class="flex flex-col w-3/4 pb-8">
          <Lynx-Label label="Documentos necessários" />

          <Treeselect
            :disabled="admin"
            :multiple="true"
            :options="lista_documentos_necessarios"
            placeholder="Selecione Documentos Necessários"
            v-model="documentos_necessarios"
          />
        </label>

        <label class="flex flex-col w-1/4 pb-8">
          <Lynx-Label label="Data para envio de NF" />
          <Lynx-Input :disabled="admin" type="date" v-model="form.envio" />
        </label>
      </div>
      <div class="flex justify-between items-center gap-4">
        <label class="flex flex-col w-2/4 pb-8">
          <Lynx-Label label="Responsavel" />
          <Lynx-Input
            :disabled="admin"
            type="text"
            v-model="form.responsavel"
          />
        </label>
        <label class="flex flex-col w-2/4 pb-8">
          <Lynx-Label label="Responsavel Telefone" />
          <Lynx-Input
            :disabled="admin"
            type="text"
            v-model="form.tel_responsavel"
          />
        </label>
      </div>
      <label class="flex flex-col w-full pb-8">
        <Lynx-Label label="Observação Tomador" />

        <vue-editor
          :disabled="admin"
          class="bg-white"
          v-model="form.observacao"
        ></vue-editor>
      </label>
      <label class="flex flex-col w-full pb-8">
        <Lynx-Label label="Descrição Nota Fiscal" />

        <vue-editor
          :disabled="admin"
          class="bg-white"
          v-model="form.descricao_notafiscal"
        ></vue-editor>
      </label>

      <!-- Adicione outros campos de acordo com sua necessidade -->

      <Lynx-Button
        :disabled="admin"
        style="color: white; float: right"
        type="submit"
        class="btn"
        >{{ lista_campos == "" ? "Criar" : "Atualizar" }}</Lynx-Button
      >
    </form>
  </div>
</template>
  
  <script>
import {
  indexEstadosRequest,
  showEstadosRequest,
} from "@/services/requests/estados";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { viaCepRequest } from "@/services/requests/viaCep";
import { VueEditor } from "vue2-editor";
import { hasRole, hasPermission } from "@/utils/can";

export default {
  components: { Treeselect, VueEditor },
  data() {
    return {
      estados: [],
      cidades: [],
      loading: false,
      cidade: null,
      emails: [""],
      form: {
        razao_social: "",
        celular: "",
        email_tomador: "",
        email_financeiro: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        cidade_id: null,
        estado_id: null,
        documentos_necessarios: null,
        cpf_cnpj: "",
        envio: null,
        observacao: "",
        notificavel: "tomador",
        descricao_notafiscal: null,
        responsavel: null,
        tel_responsavel: null,
      },
      admin: false,
      documentos_necessarios: null,
    };
  },
  watch: {
    "form.estado_id": function () {
      this.onSelectEstado(this.form.estado_id);
    },
  },
  created() {
    this.preenxer_campos();
  },
  computed: {
    lista_cidades() {
      return this.generateSelectOptions(this.cidades);
    },
    lista_estados() {
      return this.generateSelectOptions(this.estados);
    },
    lista_documentos_necessarios() {
      return [
        { id: 1, label: "CPF" },
        { id: 2, label: "Comprovante de endereço" },
        { id: 3, label: "XML" },
        { id: 4, label: "Certidões negativas" },
        { id: 5, label: "Declarações não SEFIP" },
        { id: 6, label: "Declaração simples nacional" },
        { id: 7, label: "Ficha cadastral" },
        { id: 8, label: "PGDAS" },
        { id: 9, label: "Planilha de relatório" },
        { id: 10, label: "Planilha de custos" },
        { id: 11, label: "Declaração de despesa" },
        { id: 12, label: "Declaração de INSS" },
        { id: 13, label: "Declaração de menor empregado" },
        { id: 14, label: "Solicitação de nota para empresa do cliente" },
        { id: 15, label: "Falar com local solicitando nota" },
        { id: 16, label: "Certidão negativa - Federal" },
        { id: 17, label: "Certidão negativa - Municipal" },
        { id: 18, label: "Certidão negativa - Estadual" },
        { id: 19, label: "Certidão negativa - FGTS" },
        { id: 20, label: "Certidão negativa - Trabalhista" },
        { id: 21, label: "Reter ISS" },
        { id: 22, label: "Prazo de Pagamento" },
        { id: 23, label: "Enviar arquivo de Nota Fiscal" },
        { id: 24, label: "Declarações fgts" },
      ];
    },

    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.tomador.mensagem_alert;
    },
  },
  methods: {
    hasRole,
    hasPermission,

    setEmails() {
      this.emails = [];
    },
    generateSelectOptions(data) {
      let options = [{ id: 0, label: "todas" }];
      for (let i = 0; i < data.length; i++) {
        options.push({ id: data[i].id, label: data[i].nome });
      }
      return options;
    },
    async confirm(tipo) {
      this.form.documentos_necessarios = JSON.stringify(
        this.documentos_necessarios
      );
      this.form.cpf_cnpj = this.form.cpf_cnpj.replace(/[./-]/g, "");
      this.form.email_tomador = JSON.stringify(this.emails);
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um tomadores no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },

    async create() {
      this.$store.dispatch("configEmpresa/atualizar", "");
      // console.log(this.form);
      this.loading = true;
      await this.$store.dispatch("tomador/create_tomador", this.form);

      if (this.mensagem_alert.tipo == "success") {
        this.$snack.success(this.mensagem_alert.message);

        this.$router.push({ name: "tomadores.index" });
      } else {
        this.$snack.error(this.mensagem_alert.message);
      }
      this.loading = false;
    },

    async update() {
      await this.$store.dispatch("tomador/update_tomador", this.form);

      if (this.mensagem_alert.tipo == "success") {
        this.$snack.success(this.mensagem_alert.message);

        this.$router.push({ name: "tomadores.index" });
      } else {
        this.$snack.error(this.mensagem_alert.message);
      }
      this.loading = false;
    },
    fetchEstados() {
      this.loading = true;
      indexEstadosRequest()
        .then((res) => (this.estados = res.data))
        .finally(() => (this.loading = false));
    },
    async onSelectEstado(id) {
      this.loading = true;
      await showEstadosRequest(id)
        .then((res) => (this.cidades = res.data.cidades))
        .finally(() => (this.loading = false));

      this.form.cidade_id = this.cidades.find(
        (item) => item.nome == this.cidade
      ).id;
    },

    voltar() {
      this.$router.push({ name: "tomadores.index" });
    },
    async preenxer_campos() {
      this.fetchEstados();
      if (this.lista_campos != "") {
        this.form = {
          id: this.lista_campos.id,

          razao_social: this.lista_campos.razao_social,
          celular: this.lista_campos.celular,
          // email_tomador: this.lista_campos.email_tomador,
          email_financeiro: this.lista_campos.email_financeiro,
          cep: this.lista_campos.cep,
          endereco: this.lista_campos.endereco,
          numero: this.lista_campos.numero,
          cpf_cnpj: this.lista_campos.cpf_cnpj,
          envio: this.lista_campos.envio,

          complemento: this.lista_campos.complemento,
          cidade_id: this.lista_campos.cidade_id,
          estado_id: this.lista_campos.estado_id,
          observacao: this.lista_campos.observacao,
          notificavel: this.lista_campos.notificavel,
          descricao_notafiscal: this.lista_campos.descricao_notafiscal,
        };
        this.emails = this.lista_campos.email_tomador
          ? JSON.parse(this.lista_campos.email_tomador)
          : [""];

        this.documentos_necessarios = JSON.parse(
          this.lista_campos.documentos_necessarios
        );

        if (!this.hasPermission("editar local trabalho")) {
          this.admin = true;
        }
      }
    },
    async fetchCep() {
      if (this.form.cep.length != 8) return;

      await viaCepRequest(this.form.cep)
        .then((res) => {
          if (res.data.erro) return;

          // this.form.rua = res.data.logradouro
          this.form.endereco =
            res.data.logradouro +
            " - " +
            res.data.bairro +
            " - " +
            res.data.localidade +
            " - " +
            res.data.uf;
          this.cidade = res.data.localidade;

          this.form.estado_id = this.estados.find(
            (item) => item.uf == res.data.uf
          ).id;

          // this.form.endereco.cidade = res.data.localidade
          // this.form.endereco.uf = res.data.uf
          // this.form.endereco.ibge = res.data.ibge
        })
        .catch(() => this.$snack.error("Não foi possivel encontrar o CEP"));
    },
  },
};
</script>
  